@if (readonly()) {
  <new-ui-wrapper-readonly
    [label]="label()"
    [value]="
      ngControl.value | newUiLabel: options() : optionValue() ?? null : optionLabel() ?? null : null : null : false
    "
  />
}

<new-ui-wrapper-writable
  [class.hidden]="readonly()"
  [label]="label()"
  [required]="isRequired()"
  [pristine]="ngControl.pristine"
>
  <!-- pt-6 on the track itself makes room for the floating label inside of it; a margin on the host would collapse through the floatlabel and move the label along -->
  <p-selectbutton
    class="flex"
    styleClass="pt-6!"
    [formControl]="$any(ngControl.control)"
    [options]="options()"
    [optionLabel]="optionLabel() ?? undefined"
    [optionValue]="optionValue() ?? undefined"
    [allowEmpty]="allowEmpty()"
    [multiple]="multiple()"
    (onChange)="changed.emit($event)"
  />
</new-ui-wrapper-writable>
